module.exports = __webpack_public_path__ + "img/grant-type-banner3.jpg";